import httper from '../../common/httper.js'
import Qs from 'Qs'

const creator = {}
creator.create = function(baseUrl) {
  let http = httper.create(baseUrl)
  return {
    //待发货订单列表
    getList: (data) => http.get('/delivery/order/deliveryPage', {
      params: data
    }),

    //订单详情
    getDetail: (data) => http.get('/delivery/order/get', {
      params: data
    }),
    //自提订单
    takeOrder: (data) => http.get('/delivery/order/takeOrder', {
      params: data
    }),
    //导入excel
    inexcel: (data, config) => http.post('/delivery/order/importExcel', data, config), // 导入excel
    // 导出excel
    outexcel: (data) => http.post('/delivery/order/export', Qs.stringify(data), {
      responseType: "blob"
    }),
    //保存订单信息
    save: (data) => http.post('/delivery/order/saveExpress', Qs.stringify(data)),
  }
}
export default creator



// WEBPACK FOOTER //
// ./src/services/delevery/api-creator.js